
import axios from 'axios';

const API_URL = process.env.REACT_APP_QUOTE_API;

//Send OTP

export const sendOtp = async (email) => {
  try {
    const response = await axios.post(`${API_URL}/login/sendOtp`, { email });

    // Check if the response status is 200 (successful request)
    if (response.status !== 201 ) {
      throw new Error('Failed to send OTP');
    }

    // Return the message from the response data if successful
    return response.data;  // Will contain { message: "OTP sent successfully" }
  } catch (error) {
    console.error('Error sending OTP:', error);

    // Check if the error is an Axios error and if the status is 401
    if (error.response && error.response.status === 401) {
      // Return the error message for unauthorized requests
      return error.response.data.errorMessage || 'Unauthorized access. Please check your credentials.';
    }

    // Generic error message for other errors
    return 'An error occurred while sending OTP.';
  }
};



//Verify OTP

export const verifyOtp = async (email, otp, setMessage) => {
  // Combine the array to form the full OTP
  const otpCode = otp.join('');
  
  if (!otpCode) {
    setMessage('Please enter the OTP.');
    return;
  }

  try {
    const response = await axios.post(`${API_URL}/login/verifyOtp`, { email, otp: otpCode });
    if (response && response.data && response.data.userData) {

      const user = response.data.userData;

      localStorage.setItem('user', JSON.stringify(user)); // Store user details as a JSON string
    }

    // Check if the response status is 200 (success)
    if (response.status !== 200) {
      throw new Error('Failed to verify OTP');
    }

    return response.data; // Should contain success response if OTP is correct

  } catch (error) {
    const errorMessage = error.response?.data?.error || 'An error occurred while verifying OTP.';
    setMessage(errorMessage); // Set message based on response or fallback
  }
};


//SignUp

export const signUp = async (userDetails) => {
  try {
    const response = await axios.post(`${API_URL}/login/signUp`, userDetails);
    if (response && response.data) {
      localStorage.setItem('token', response.data.token);
      return response.data;
    } else {
      throw new Error('Unexpected response structure');
    }
  } catch (error) {
    if (error.response && error.response.data) {
      throw error.response.data;
    } else {
      throw new Error('Failed to connect to the server');
    }
  }
};



export const getDropdownData = async () => {
  try {
    const response = await fetch(`${API_URL}/login/userTypes`);
    
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const data = await response.json();
    
    if (data.status === 200) {
      return data.payLoad; // Return payload if status is 200
    } else {
      throw new Error(`API returned status: ${data.status}`);
    }
  } catch (error) {
    console.error('Error fetching user types:', error);
    throw error; // Rethrow error so calling code can handle it
  }
};